import { User02 } from "../../../assets/CustomSvgs";
import { useAuth } from "../../../contexts/AuthContext";

export const LoginButton = () => {
  const auth = useAuth();

  return (
    <button
      onClick={() => auth.login()}
      className="auth-button sign-in"
    >
      <User02 width={20} height={20} />
      Sign In
    </button>
  );
};